import { autoImportModules } from '~/utils/autoImport'

// 自动导入当前目录下的所有 .ts 文件
const modules = import.meta.glob('./*.ts', { eager: true })
const langModules = autoImportModules(modules)

export default {
  ...langModules
}
